export default {
  CONTRIBUTION: 'Contribution',
  ADD_NEW_CONTRIBUTION: 'Add New Contribution',
  ADD_NEW_PLEDGE: 'Add New Pledge',
  CONTRIBUTION_ALREADY_LINKED_TO_PLEDGE:
    'This contribution is already linked to a pledge.',
  DONATION_FUNDRAISING_PAGE: 'Fundraising Page',
  DONATION_GENERAL: 'General',
  DONATION_HISTORY: 'Contribution Giving History',
  DONATION_PLEDGE: 'Pledge',
  DONATION_RECURRING: 'Recurring',
  DONATION_RESTRICTED: 'Restricted Gift',
  DONATION_IN_KIND: 'In Kind',
  DONATION_PLANNED: 'Planned Giving',
  DONATION_TIME: 'Time',
  DONATION_GRANT: 'Grant',
  DONATION_SPONSORSHIP: 'Sponsorship',
  DONATION_TICKET: 'Ticket',
  CONTRIBUTION_AMOUNT_LABEL: 'Total Contribution Amount',
  DONATION_AMOUNT_RECONCILED: 'Amount Reconciled',
  DONATION_AMOUNT_RECONCILED_MOBILE: 'Reconciled',
  CONTRIBUTION_AMOUNT_ERROR_REQUIRED: 'Amount Required',
  CONTRIBUTION_ENTITY_SUMMARY: `{constituentLink} made a {donationType} contribution of {amount}{hasCampaign, select, true { to {campaignLink}} other {}} on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_GENERAL: `{constituentLink} 💪 contributed {amount} via {paymentMethod}{hasCampaign, select, true { to {campaignLink}} other {}} on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_GRANT: `A 📜 {amount} grant has been awarded to us by {constituentLink}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_PLEDGE: `{constituentLink} ✋ pledged {amount} via {paymentMethod} on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_TIME: `{constituentLink} contributed {time} {timeUnit} of {timeValue} value time in the {category} category on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_TIME_FOR_CAMPAIGN: `{constituentLink} contributed {time} {timeUnit} of {timeValue} value time in the {category} category for the {campaignLink} campaign on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  CONTRIBUTION_ENTITY_SUMMARY_SPONSORSHIP: `{constituentLink} contributed a {amount} sponsorship via {paymentMethod} {hasCampaign, select, true { to {campaignLink}} other {}} on {date}`,
  CONTRIBUTION_ENTITY_SUMMARY_TICKET: `
{constituentLink}
{hasQuantity, select, true
  {committed {quantity, plural, one {one Ticket} other {{quantity} Tickets}}}
  other {made a ticket contribution}
}
 for {amount} {hasCampaign, select, true { to {campaignLink}} other {}} on {date}
{source, select,
  classy { through <strong>Classy</strong>}
  stripe { through <strong>Stripe</strong>}
  eventbrite { through <strong>Eventbrite</strong>}
  salesforce { through <strong>Salesforce</strong>}
  pledge { via fundraising page}
  other {}
}
`,
  CONTRIBUTION_ENTITY_SUMMARY_FOR: `{constituentLink} made {type, select, in_kind {an} other {a}} {donationType} contribution of {amount} for {subject} on {date}{source, select,
classy { through <strong>Classy</strong>}
stripe { through <strong>Stripe</strong>}
eventbrite { through <strong>Eventbrite</strong>}
salesforce { through <strong>Salesforce</strong>}
pledge { via fundraising page}
other {}
}`,
  DONATION_DATE_DUE: 'Date Due',
  DONATION_DATE_DUE_MOBILE: 'Due',
  DONATION_DATE_PLEDGED: 'Date Pledged',
  DONATION_DATE_PLEDGED_MOBILE: 'Pledged',
  DONATION_LAST_UPDATED: 'Last updated {date}',
  DONATION_LINK: 'Link',
  CONTRIBUTION_LINK_TO_CONTRIBUTION: 'Link to contribution',
  DONATION_LINK_TO_PLEDGE: 'Link to a Pledge',
  CONTRIBUTION_LINKED_CONTRIBUTIONS: 'Linked contributions',
  CONTRIBUTION_LINKED_TO_A_PLEDGE:
    'Contribution linked to a <a>{amount} Pledge</a>',
  CONTRIBUTION_LINK_TO_EXISTING_PLEDGE:
    'Link contribution to an existing pledge?',
  CONTRIBUTION_LINK_TO_DIALOG_ERROR:
    'There was a problem linking contributions. Please try again',
  CONTRIBUTION_LINK_TO_DIALOG_HEADER: 'Link to Contribution ({displayName})',
  DONATION_LINK_TO_PLEDGE_DIALOG_HEADER: 'Link to a Pledge ({displayName})',
  DONATION_LINK_TO_PLEDGE_DESCRIPTION:
    'Connect this contribution with a pledge from the list below.',
  CONTRIBUTION_LINK_TO_DIALOG_SUCCESS: 'Your contribution(s) have been linked',
  CONTRIBUTION_UNLINK_SUCCESS: 'Your contribution was unlinked from a pledge',
  CONTRIBUTION_UNLINK_ERROR:
    'There was a problem linking contributions. Please try again',
  DONATION_NOTES_LABEL: 'Notes',
  DONATION_CONTACT_NAME_LABEL: 'Contact Name',
  DONATION_CONTACT_NAME_ERROR_REQUIRED: 'Contact Name Required',
  CONTRIBUTION_TYPE_LABEL: 'Contribution Type',
  CONTRIBUTION_TYPE_ERROR_REQUIRED: 'Contribution Type Required',
  DATE_LABEL: 'Date',
  CONTRIBUTION_DATE_LABEL: 'Date',
  CONTRIBUTION_DATE_ERROR_REQUIRED: 'Date Required',
  DONATION_OUTSTANDING_PLEDGES: 'Pledges ({totalHits})',
  DONATION_PAYMENT_CASH: 'Cash',
  DONATION_PAYMENT_CHECK: 'Check',
  DONATION_PAYMENT_CREDIT_CARD: 'Credit Card',
  DONATION_PAYMENT_BANK_WIRE: 'Wire Transfer',
  DONATION_PAYMENT_APP: 'Payment App',
  DONATION_PAYMENT_CRYPTO: 'Cryptocurrency',
  DONATION_PAYMENT_LABEL: 'Payment Method',
  DONATION_PAYMENT_UNKNOWN: 'Offline',
  DONATION_PAYMENT_ERROR_REQUIRED: 'Payment Method Required',
  DONATION_PLEDGES: 'Pledges',
  DONATION_PLEDGE_DUE_BY: '(Due {dueDate})',
  DONATION_RECONCILED: 'Reconciled',
  CONTRIBUTION_UNLINK_DONATION: 'Unlink Contribution',
  EDIT_CONTRIBUTION: 'Edit Contribution',
  PLEDGE_AMOUNT_LABEL: 'Pledge Amount',
  PLEDGE_AMOUNT_ERROR_REQUIRED: 'Pledge Amount Required',
  PLEDGE_DUE_DATE_LABEL: 'Pledge Due Date',
  PLEDGE_DUE_DATE_ERROR_REQUIRED: 'Pledge Due Date Required',
  PLEDGED_LABEL: 'Pledged',
  DUE_LABEL: 'Due',
  RECURRING_CADENCE_CRITERIA_LABEL: 'Recurring Contribution Cadence',
  RECURRING_CADENCE_LABEL: 'Cadence',
  RECURRING_CADENCE_ERROR_REQUIRED: 'Cadence Required',
  RECURRING_START_DATE_LABEL: 'Start Date',
  RECURRING_START_DATE_ERROR_REQUIRED: 'Start Date Required',
  RESTRICTION_AREA_LABEL: 'Area of Restriction',
  RESTRICTION_AREA_ERROR_REQUIRED: 'Area of Restriction Required',
  IN_KIND_ITEM_CONTRIBUTED_LABEL: 'Item Contributed',
  IN_KIND_ITEM_CONTRIBUTED_ERROR_REQUIRED: 'Item Contributed Required',
  IN_KIND_ITEM_QUANTITY_LABEL: 'Quantity',
  IN_KIND_ITEM_QUANTITY_ERROR_REQUIRED: 'Quantity Required',
  IN_KIND_ITEM_VALUE_LABEL: 'Value',
  IN_KIND_ITEM_VALUE_ERROR_REQUIRED: 'Value Required',
  PLANNED_GIVING_ESTIMATED_CONTRIBUTION_VALUE_LABEL: 'Estimated Value',
  PLANNED_GIVING_ESTIMATED_CONTRIBUTION_VALUE_ERROR_REQUIRED:
    'Estimated Value Required',
  CONTRIBUTION_CREATION_SUCCESS: 'Contribution successfully created',
  CONTRIBUTION_CREATION_FAILURE: 'Error, contribution creation failed',
  CONTRIBUTE_DELETE_CONFIRMATION:
    'Are you sure you want to delete this contribution?',
  CONTRIBUTION_DELETE_CONTRIBUTION: 'Delete Contribution',
  CONTRIBUTION_DELETE_SUCCESS: 'Contribution successfully deleted',
  CONTRIBUTION_DELETE_FAILURE: 'Error, contribution deletion failed',
  CONTRIBUTION_UPDATE_SUCCESS: 'Contribution successfully updated',
  CONTRIBUTION_UPDATE_FAILURE: 'Error, contribution update failed',
  DONATION_VOLUNTEER_LABEL: 'Volunteer Type',
  DONATION_VOLUNTEERED_EVENTS: 'Events',
  DONATION_VOLUNTEERED_CAMPAIGNS: 'Campaigns',
  DONATION_VOLUNTEERED_GENERAL: 'General',
  DONATION_VOLUNTEERED_GIFTS: 'Gifts',
  DONATION_VOLUNTEERED_OPERATIONS: 'Operations',
  DONATION_VOLUNTEERED_GRANTS: 'Grants',
  DONATION_VOLUNTEERED_GOVERNANCE: 'Governance',
  DONATION_VOLUNTEERED_ADVOCACY: 'Advocacy',
  DONATION_VOLUNTEERED_OTHER: 'Other',
  CONTRIBUTION_VOLUNTEER_ERROR_REQUIRED: 'Contribution Volunteer Type Required',
  DONATION_TIME_VALUE_LABEL: 'Value',
  DONATION_VERY_HIGH_VALUE: 'Very High',
  DONATION_HIGH_VALUE: 'High',
  DONATION_MODERATE_VALUE: 'Moderate',
  DONATION_LOW_VALUE: 'Low',
  DONATION_MINOR_VALUE: 'Minor',
  DONATION_VALUE_REQUIRED: 'Value Required',
  DONATION_TIME_AMOUNT: 'Amount of Time',
  DONATION_TIME_AMOUNT_REQUIRED: 'Amount of Time Required',
  DONATION_TIME_TYPE: 'Type',
  DONATION_TIME_TYPE_REQUIRED: 'Type Required',
  DONATION_MINUTES: 'Minutes',
  DONATION_HOURS: 'Hours',
  DONATION_DAYS: 'Days',
  DONATION_CAMPAIGN: 'Campaign',
  DONATION_EVENTS: 'Events',
  DONATION_CAMPAIGNS: 'Campaigns',
  DONATION_GENERAL_CORPORATE: 'General Corporate',
  DONATION_GIFTS: 'Major Gifts',
  DONATION_OPERATIONS: 'Admin/Operations',
  DONATION_FOUNDATIONS: 'Foundations',
  DONATION_ADVOCACY: 'Advocacy',
  DONATION_PLANNED_GIFTS: 'Planned Gifts',
  DONATION_START_DATE_CADENCE: 'Start Date - Cadence',
  RECURRING_DONATION_BIWEEKLY_LABEL: 'Bi-weekly (every 2 weeks)',
  RECURRING_DONATION_DAILY_LABEL: 'Daily',
  RECURRING_DONATION_MONTHLY_LABEL: 'Monthly',
  RECURRING_DONATION_QUARTERLY_LABEL: 'Quarterly (every 3 months)',
  RECURRING_DONATION_SEMIANNUALLY_LABEL: 'Semi-annually (every 6 months)',
  RECURRING_DONATION_WEEKLY_LABEL: 'Weekly',
  RECURRING_DONATION_YEARLY_LABEL: 'Yearly',
  GRANT_AMOUNT_LABEL: 'Grant Amount',
  GRANT_NAME_LABEL: 'Grant Name',
  FUNDING_ORGANIZATION_LABEL: 'Funding Organization',
  RESTRICTED_LABEL: 'Restricted',
  DONATION_INTEGRATION_INFO_STRIPE_TITLE: 'Stripe',
  DONATION_INTEGRATION_INFO_STRIPE_LINK: 'View in Stripe',
  CONDITIONS_OF_RESTRICTION_LABEL: 'Conditions of Restriction',
  ASSOCIATED_TEAM_MEMBERS_LABEL: 'Associated Team Members',
  CONTRIBUTIONS_FETCH_ERROR: 'There was a problem fetching contributions.',
  CONSTITUENT_HAS_NO_CONTRIBUTIONS:
    'This constituent has no contributions. Would you like to add one?',
  CONSTITUENT_HAS_NO_PLEDGES:
    'This constituent has no pledges. Would you like to add one?',
  CONFIRM_REMOVE_LINKED_CONTRIBUTION:
    'Are you sure you want to remove this linked contribution? It will no longer be associated with this pledge.',
  CONTRIBUTION_CADENCE: 'Contribution Cadence',
  DONATION_CADENCE_DAY: 'Daily',
  DONATION_CADENCE_WEEK: 'Weekly',
  DONATION_CADENCE_BIWEEK: 'Biweekly',
  DONATION_CADENCE_MONTH: 'Monthly',
  DONATION_CADENCE_QUARTER: 'Quarterly',
  DONATION_CADENCE_SEMIANNUAL: 'Semiannual',
  DONATION_CADENCE_YEAR: 'Yearly',
  DONATIONS: 'Donations',
  EARNED_REVENUE: 'Earned Revenue',
  CONTRIBUTION_AMOUNT: 'Contribution Amount',
  DONATION_AMOUNT: 'Donation Amount',
  EARNED_REVENUE_AMOUNT: 'Earned Revenue Amount',
  INCLUDE_EARNED_REVENUE: 'Include Earned Revenue',
  SOFT_CREDIT: 'Soft Credit',
  SOFT_CREDITS: 'Soft Credits',
  EXPORT_LIST: 'Export {resourceType} List',
  CONTRIBUTION_DATE: 'Contribution Date',
  PLEDGED_AMOUNT: 'Pledged Amount',
  PLEDGED_AMOUNT_RECEIVED: 'Received Amount',
  CONTRIBUTION_FMV: 'Fair Market Value',
  CONTRIBUTION_FEES: 'Fees',
  CONTRIBUTION_TAXES: 'Taxes',
  CONTRIBUTION_TOTAL_CONTRIBUTIONS: 'Total Contributions',
  CONTRIBUTION_TOTAL_DONATIONS: 'Total Donations',
  CONTRIBUTION_TOTAL_DONATIONS_ESTIMATED: 'Estimate based on available data.',
  CONTRIBUTION_VALUE_IN_KIND: 'Contribution Value (In Kind)',
  CONTRIBUTION_ITEM_IN_KIND: 'Contribution Item (In Kind)',
  CONTRIBUTION_ITEM_QUANTITY_IN_KIND: 'Contribution Item Quantity (In Kind)',
  CONTRIBUTIONS_TABLE_HEADER: 'Contributions ({count})',
  CONTRIBUTION_TIME: 'Contribution Time (Hours)',
  DEDICATION: 'Dedication',
  DEDICATION_ATTRIBUTION: '{type} of {attribution}',
  DEDICATION_IN_HONOR: 'In Honor',
  DEDICATION_IN_MEMORY: 'In Memory',
  DEDICATION_IN_HONOR_MEMORY: 'In Honor/Memory',
  DEDICATED_TO: 'Dedicated To',
  DEDICATION_TYPE: 'Dedication Type',
  DEDICATION_TYPE_ERROR_REQUIRED: 'Required for dedications',
  CONTRIBUTION_TOTAL_AMOUNT: 'Single Contribution Amount',
  CONTRIBUTION_TOTAL_TIME: 'Single Contribution Hours',
  CONTRIBUTION_MADE: 'Contribution Made',
  CONTRIBUTION_FROM_INTEGRATION_EDIT_WARNING:
    'Note: You are currently editing data from a third-party source. Any changes you make here may result in discrepancies between our system and theirs.',
  X_CONTRIBUTIONS:
    '{contributions} {contributions, plural, =1 {Contribution} other {Contributions}}',
  NO_CONTRIBUTIONS_TO_DISPLAY: 'There are no contributions to display.',
};
